import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const PencilGlyph = /*#__PURE__*/createElement("g", {
  id: "pencil"
}, /*#__PURE__*/createElement("path", {
  d: "M69.2 27.58L56.42 14.8a1.038 1.038 0 00-1.46 0L24.92 44.84l-2.68 2.66.01.01-.93.93.01.01L14.5 69.5l21.05-6.83.01.01L69.2 29.04c.4-.4.4-1.06 0-1.46zM20.68 60.47l2.59-7.98 8.25 8.25-7.98 2.59-2.86-2.86zm13.69-1.11l-3.84-3.84 31.19-31.04 3.84 3.84-31.19 31.04zM59.6 22.35L28.41 53.4l-3.91-3.91 31.19-31.04 3.91 3.9z"
}));
const Pencil = createSvg({
  name: 'pencil',
  path: PencilGlyph
});

export default Pencil;
export { PencilGlyph };
